import { useState } from 'react';

import { LelandSessionStorage } from '../storage';

interface SessionStateOptions<T> {
  key: string;
  defaultValue?: T;
  onStateChange?: (value: T | null) => void;
}

export function useSessionState<T>({
  key,
  defaultValue,
  onStateChange,
}: SessionStateOptions<T>) {
  const [state, setState] = useState<T | null>(() => {
    if (defaultValue === undefined) {
      return LelandSessionStorage.getItem<T>(key);
    }
    return LelandSessionStorage.getItem<T>(key, defaultValue);
  });

  const setSessionState = (value: T | null) => {
    if (value === null) {
      LelandSessionStorage.removeItem(key);
      setState(null);
      onStateChange?.(null);
    } else {
      LelandSessionStorage.setItem(key, value);
    }
    setState(value);
    onStateChange?.(value);
  };

  return [state, setSessionState] as const;
}
